
<v-form ref="form" class="w-100" v-if="item">
    <v-container fluid class="pa-0">
        <v-row class="no-frame">
            <v-col  >
                <f-title :title="$t('inb.detail.head.title')" />
                <v-row dense class="mb-5">
                    <v-col class="pa-0">
                        <c-inb-context
                            :item     = "item"
                            :readonly = "readonly"
                            @morph    = "onMorph"
                            @changed  = "onContext"
                            ref       = "siteselect"
                        />
                    </v-col>
                </v-row>
            </v-col>

            <v-col >
                <f-title title="Rechnung" class=" mt-0"/>
                <inb-invoice-types
                    v-model    = "item.invoiceType"
                    category   = "invoice"
                    label      = "Rechnungsart"
                    :rules     = "[rules.requiredcombo]"
                    :readonly  = "readonly"
                    :clearable = "!readonly"
                    @change    = "onInvoiceType"
                />

                <f-title title="Rechnungsdaten" class="mt-5" />
                <v-text-field
                    v-model        = "item.ordernumber"
                    label          = "Auftragsnummer"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    class          = "mt-6"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
                <v-text-field
                    v-model        = "item.invoicenumber"
                    label          = "Rechnungsnummer"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
                <f-date-picker
                    label     = "Rechnungsdatum"
                    :readonly = "readonly"
                    :time     = "false"
                    v-model   = "item.invoiceDate"
                />

                <f-currency-field
                    v-model   = "item.netamount"
                    :readonly = "readonly"
                    label     = "Gesamtbetrag (netto)"
                />
            </v-col>
        </v-row>
    </v-container>
</v-form>
